import React, { useState, useEffect, useContext } from 'react';
import Cookies from 'js-cookie';

import Dropdown from '../common/Dropdown'

import LOAD_CHAR from '../Charsheet0/helpers/load_char2.js'
import SAVE_CHAR from '../Charsheet0/helpers/save_char.js'
import DELETE_CHAR from '../Charsheet0/helpers/delete_char.js'
import flatten from '../Charsheet0/helpers/flatten.js'
import unflatten from '../Charsheet0/helpers/unflatten.js'

import handleCharChange from '../../helpers/handleCharChange.js'

import { UserDataContext } from "../../App.js";
import { DIRTY_SAVEBUTTON_STYLE } from '../../globals.js';

// ----------------------------------------------------------------------------------
//                         Description
//
//     What does NavBarButton do?
//
//     (c) DXA Development 2023
// ----------------------------------------------------------------------------------

function LoadSaveButton(props) {

    // ------------ parameters ---------------

    // ------ inherited state variables ------
    let [charData, setCharData, currentChar, setChar ] = props.state;
    const [userData, setUserData] = useContext(UserDataContext);
    var spellCheckArray=props.spellCheckArray;
    const isDirty = props.isDirty;
    const setIsDirty = props.setIsDirty;

    // -------- local state variables --------

    // ------------- useEffect ---------------

    useEffect( () => {

        async function DoSomething () {    

        }

        DoSomething();

    },); //useEffect

    // ---------- return html (jsx) ----------

    const options = ['Load Character', 'Save Character'];
    if ( userData.loggedIn ) options.push('Delete');
    

    const handleMenu = async function (selection) {

      switch( options[selection] ) {

        case('---'):
          break;

        case('Load Character'):
          console.log('CBUTTON currentChar ',currentChar)
          handleLoad(currentChar, userData);
          break;
        
        case('Save Character'):
          let cs = unflatten(charData);
          console.log ('cs data: ', cs);

          if ( userData.loggedIn ) {
            // save the character data in to dynamoDB
            // const currentCampaign = Cookies.get('currentCampaign')
            const currentCampaign = userData.currentCampaign

            const result = await SAVE_CHAR(cs, cs.name, currentCampaign )

            handleCharChange(result, userData, setUserData, currentChar, setChar, currentCampaign);
            setIsDirty(false);

          } else {
              alert('Log in required\n\nSettings > Log In')
          }
          break;
        
        case('Save Backup'):
          alert('Not implemented yet, use Characters > Save Local Backup')
          let cs2 = unflatten(charData);
          console.log ('Save Backup ', cs2);
          
          break;  

        case('Delete'):
          let deleteName = currentChar; // default to the character name passed in
          const currentCampaign = Cookies.get('currentCampaign')
          const result = await DELETE_CHAR(deleteName, currentCampaign)
          console.log('Delete result:', result);
          handleCharChange(result, userData, setUserData, currentChar, setChar, currentCampaign);

          break;

        default:
          handleLoad(options[selection]);
          break;
      }
    }

    const handleLoad = async ( charname = '', userData ) => {

      if ( charname === '' ) {
          const result = await LOAD_CHAR('', setCharData, true, userData, 'LoadSave Button');
          const new_data = result.data;
          const flatCharData = flatten(new_data)

          setCharData(flatCharData)
          setIsDirty(result.usedCache);

      // set spell check data
      if (spellCheckArray) {
        for (let i=11; i<=55; i++) {
          const spellCheckVarName = "mySpk" + String(i)

          // the second item in the Array is the update function
          let updateSpellCheck = spellCheckArray[i][1]

          const spellChecksThis = flatCharData[spellCheckVarName]

          // set the data if it exists
          if (typeof spellChecksThis !== 'undefined') {
            updateSpellCheck( spellChecksThis )

          } else {
          // set to Empty if no data
            console.log('spellCheck data missing')
            updateSpellCheck(['Empty','Empty','Empty','Empty','Empty','Empty'])
          }

        }
      }


        } else {
        console.log('Load character:', charname);
        console.log('userData:', userData);
          const result = await LOAD_CHAR(charname, setCharData, true, userData);
          const new_data = result.data;
          setCharData(flatten(new_data))
          setChar(new_data['name'])
          setIsDirty(result.usedCache);
      }
    }

    return (
        <>
        <Dropdown
            trigger = {<button id="nav-menu-characters" className="cf-load-but no-print" style={isDirty ? DIRTY_SAVEBUTTON_STYLE : {}}>Load/Save</button>}
            menu = { options.map ( ( option, idx) =>
                { return <button style={isDirty && option.includes('Save') ? { color: DIRTY_SAVEBUTTON_STYLE.border.split(' ').at(-1) } : {}} onClick={()=>handleMenu(idx)}>{option}</button>}
            )}
            divClass='character-dropdown-full'
            menuClass='characters-menu-full character-menu' 
        />
        </>
    )

    };  // end of function

    export default LoadSaveButton